module.exports = __webpack_public_path__ + "img/pdf-file.841e5d21.svg";